import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Surface } from "@core/components/ui/surface";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface RegistrationConfirmProviderMessageProps {
  success: boolean;
}
const RegistrationConfirmProviderMessage = ({ success }: RegistrationConfirmProviderMessageProps) => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();
  const isProviderRegistration = getValues("Tags.IsProviderRegistration") === "true";
  if (!isProviderRegistration || !success) {
    return null;
  }
  return (
    <Surface variant="success">
      <p className="text-center">
        {t("registration.provider.confirmation", "Thank you for registering as a provider. Your registration is pending approval. You will receive an email when your account is approved.")}
      </p>
    </Surface>
  );
};

registerExtension("_site.registration.confirm.success", RegistrationConfirmProviderMessage, "RegistrationConfirmProviderMessage");
